import 'script-loader!./vendor/jquery-1.11.2.min.js';
import 'script-loader!./vendor/jquery.magnific-popup.min.js';
import 'script-loader!../../vendor/nette/forms/src/assets/netteForms.js';
import 'script-loader!../../vendor/vojtech-dobes/nette.ajax.js/nette.ajax.js';
import 'script-loader!../../vendor/vojtech-dobes/nette.ajax.js/extensions/spinner.ajax.js';
import 'script-loader!../../vendor/uestla/recaptcha-control/src/assets/recaptcha.js';


// WEBPACK FOOTER //
// ./www/js/vendor.js